import { Component, OnInit } from "@angular/core";
import {
  ADMIN_ROUTES,
  EMPLOYEE_ROUTES,
  MARKETING_ROUTES,
} from "./side-nav-routes.config";
import { ThemeConstantService } from "../../services/theme-constant.service";
import { AccountService } from "src/app/core";

@Component({
  selector: "app-sidenav",
  templateUrl: "./side-nav.component.html",
  styleUrls: ["./side-nav.component.scss"],
})
export class SideNavComponent implements OnInit {
  public menuItems: any[];
  isFolded: boolean;
  isSideNavDark: boolean;

  constructor(
    private themeService: ThemeConstantService,
    private accountService: AccountService
  ) {}

  ngOnInit(): void {
    const accountInfo = this.accountService.getInfo() || {adminGroup: {}};
    const code = accountInfo.adminGroup.code;
    let routers = ADMIN_ROUTES;
    switch (code) {
      case "SUPERVISOR":
        routers = ADMIN_ROUTES;
        break;
      case "ADMIN":
        routers = ADMIN_ROUTES;
        break;
      case "EMPLOYEE":
        routers = EMPLOYEE_ROUTES;
        break;
      case "MKT_EMPLOYEE":
        routers = MARKETING_ROUTES;
        break;
    }
    this.menuItems = routers.filter((menuItem) => menuItem);
    this.menuItems.forEach((item) => {
      item.selected = false;
      item.subMenuSelected = false;
    })
    this.themeService.isMenuFoldedChanges.subscribe(
      (isFolded) => (this.isFolded = isFolded)
    );
    this.themeService.isSideNavDarkChanges.subscribe(
      (isDark) => (this.isSideNavDark = isDark)
    );
  }
}
